export default __webpack_public_path__ + "static/media/Plissee 18 mm reversibel ausmessen.f780db3f.jpg";